module.exports = __webpack_public_path__ + "static/media/KN2@2x.e19fd3a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/KN/KN2@2x.png
// module id = 665
// module chunks = 0